import React from 'react';
import { Link } from 'react-router-dom';
import { renderDate } from '#component/form/select';
import { DotsCntPopup, DotIcon, StyledMenuItem } from './styles';

const renderItem = (data, html = [], account, isMobile) => {
  data.forEach((f, j) => {
    html.push(
      <StyledMenuItem
        component={Link}
        to={`/project/edit/${f.id}`}
        key={f.id}
        value={f.id}
        disabled={j === 0}
      >
        <DotsCntPopup>
          {f.ancestors && f.ancestors.map((a, i) =>
            <DotIcon
              key={i}
              fontSize="inherit"
            />) }
        </DotsCntPopup>
        <span style={{ marginRight: 8, maxWidth: '80%' }}>{f.title}</span>
        {renderDate(f, account, isMobile)}
      </StyledMenuItem>
    );
  });
  return html;
};

export default renderItem;
